import React, { Fragment, Component } from "react";
import uuid from "react-native-uuid";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Button } from "@revvsales/components";
import Modal from "react-responsive-modal";

import CustomQuoteTableWrapper from "./CustomQuoteTableWrapper";
import Table from "../RevvTable";
import { COMMON, DOCUMENTS } from "../../constants";
import {
  getGroupSummaryData,
  getDealTableColumns,
  getUngroupedData,
  getGroupedData,
  getMergeGroups,
} from "../../utils/documentUtils";
import { checkAppFlag, numberForamting } from "../../utils/globalUtils";
import { ReactSelect } from "../../commonComponents";

// Actions Imports
import { QuotationActions } from "../../actions";
import MergeGroups from "./MergeGroups";
import { updateDocumentClickedComponentID } from "../../actions/DocumentActions/index";

// Destructuring
const { toggleTabAndToolPanelData } = QuotationActions;
const { APP_FLAGS, CURRENCY_SYMBOL, DEAL_LABELS } = COMMON;
const { DEALTABLE_VIEW, DEALTABLE_GROUPVIEW_HEADERS } = DOCUMENTS;

// Decalarations
const DEAL_TABLE = "DEAL_TABLE";

class CustomDealTable extends Component {
  state = {
    mergeGroup: false,
    editMergeGroupID: null,
    selectedGroups: [],
    showMergeGroupNamePopup: false,
    unmergedGroupExists: true,
  };

  componentDidUpdate(prevProps, prevState) {
    // if preview redlining is turned on or
    // the doc is moved to isLocked state
    // the group merge UI needs to be reset to default view (ie Normal View and no checkboxes)
    const { showDocumentDiffView, isLocked, dealtableView } = this.props;
    const {
      showDocumentDiffView: prevShowDocDiffView,
      isLocked: prevIsLocked,
    } = prevProps;
    const { mergeGroup: prevMergeGroup } = prevState;

    if (
      (prevShowDocDiffView === false && showDocumentDiffView === true) ||
      (prevIsLocked === false && isLocked === true)
    ) {
      this._changeDataView(dealtableView);
    }
    if (
      prevShowDocDiffView === false &&
      showDocumentDiffView === true &&
      prevMergeGroup
    ) {
      // this rule ignore is valid
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ mergeGroup: false, selectedGroups: [] });
    }
  }

  _openDealTable = event => {
    if (!this.props.isSharedDocument) {
      event.stopPropagation();
      this.props.toggleTabAndToolPanelData({
        tabView: DEAL_TABLE,
        dealTableId: this.props.dealTableId,
        isOpen: false,
        panelView: null,
        page: DEAL_TABLE,
      });
    }
  };

  _changeDataView = view => {
    const { section, handleBlur, isLocked } = this.props;
    section.dealtableView = view;
    if (isLocked === false) {
      handleBlur(section);
    }
  };

  _updateGroupSummary = tableData => {
    const { data } = tableData;
    const selectedGroups = data.data
      .filter(row => row.data[0].data)
      .map(row => row.attributes.id);
    this.setState({ selectedGroups });
  };

  _closeMergeGroupPopUp = () => {
    this.setState({ showMergeGroupNamePopup: false, editMergeGroupID: null });
  };

  _openMergeGroupPopUp = () => {
    this.setState({ showMergeGroupNamePopup: true });
  };

  _editMergeGroup = mergeGroupID => {
    this.setState({
      showMergeGroupNamePopup: true,
      editMergeGroupID: mergeGroupID,
    });
  };

  _discardMergeGroup = mergeGroupID => {
    const { section, handleBlur, groupSummary } = this.props;

    const {
      mergeGroupMapping = [],
      mergeGroupMetaData = [],
    } = groupSummary || {
      mergeGroupMapping: [],
      mergeGroupMetaData: [],
    };

    if (
      !(Array.isArray(mergeGroupMetaData) && Array.isArray(mergeGroupMapping))
    )
      return;

    const newMergeGroupMetaData = mergeGroupMetaData.filter(
      group => group.id !== mergeGroupID,
    );

    const newMergeGroupMapping = mergeGroupMapping.filter(
      group => group.mergeGroupID !== mergeGroupID,
    );

    section.data = {
      ...section.data,
      groupSummary: {
        mergeGroupMetaData: newMergeGroupMetaData,
        mergeGroupMapping: newMergeGroupMapping,
      },
    };
    handleBlur(section);
  };

  _createMergeGroup = (id, groupName, total) => {
    const { selectedGroups } = this.state;
    const { section, handleBlur, groupSummary, discount } = this.props;
    const {
      mergeGroupMapping = [],
      mergeGroupMetaData = [],
    } = groupSummary || {
      mergeGroupMapping: [],
      mergeGroupMetaData: [],
    };
    let newGroupSummary = {};
    if (!id) {
      const mergeGroupID = uuid.v4();
      const newGroupMapping = mergeGroupMapping.filter(
        mapping => !selectedGroups.includes(mapping.groupID),
      );
      const newObjForCreateGroupData = discount.groups.filter(mapping =>
        selectedGroups.includes(mapping.id),
      );
      newObjForCreateGroupData.forEach(groupID => {
        newGroupMapping.push({
          groupID: groupID.id,
          group_by_value: groupID.group_by_value,
          group_by: groupID.group_by,
          mergeGroupID,
        });
      });
      mergeGroupMetaData.push({
        id: mergeGroupID,
        label: groupName,
        total,
      });

      newGroupSummary = {
        mergeGroupMapping: newGroupMapping,
        mergeGroupMetaData,
      };
    } else {
      const newMergeGroupMetaData = mergeGroupMetaData.map(group => {
        if (group.id === id) {
          group.label = groupName;
          group.total = total;
        }
        return group;
      });
      newGroupSummary = {
        ...groupSummary,
        mergeGroupMetaData: newMergeGroupMetaData,
      };
    }

    section.data = {
      ...section.data,
      groupSummary: newGroupSummary,
    };

    handleBlur(section);
    this.setState({
      selectedGroups: [],
      mergeGroup: false,
      showMergeGroupNamePopup: false,
      editMergeGroupID: null,
    });
  };

  _validateMergeButton = () => {
    const { selectedGroups } = this.state;
    if (!Array.isArray(selectedGroups) || selectedGroups.length === 0) {
      return false;
    }
    return true;
  };

  _setMergeGroup = () => {
    if (this.state.unmergedGroupExists) {
      this.setState({ mergeGroup: true });
    } else {
      Toastr.showToastr({
        type: "success",
        message: "No groups left to merge",
        timeout: 3000,
      });
    }
  };

  _dealtableHeader = () => {
    const { discount, dealtableView, showDocumentDiffView } = this.props;
    const { mergeGroup } = this.state;
    const groupingPresent =
      discount && discount.groups && discount.groups.length > 0;
    if (!groupingPresent || showDocumentDiffView) return null;

    const value = DEALTABLE_VIEW.find(view => view.type === dealtableView);
    return !mergeGroup ? (
      <div className="dealtable-btns-wrapper">
        {dealtableView === "GROUPED_SUMMARY" && (
          <Button
            data-test="custom-deal-table-merge-groups-btn"
            className="revv-btn-secondary-sm"
            onClick={() => this._setMergeGroup()}>
            Merge groups
          </Button>
        )}
        <ReactSelect
          data-test="custom-deal-table-change-data-view"
          onChange={v => this._changeDataView(v.value)}
          options={DEALTABLE_VIEW}
          value={value && value.label}
          valueKey="type"
          labelKey="label"
        />
      </div>
    ) : (
      <div className="dealtable-btns-wrapper">
        <Button
          data-test="custom-deal-table-merge-discard-btn"
          className="btn-default revv-btn-sm"
          onClick={() =>
            this.setState({ mergeGroup: false, selectedGroups: [] })
          }>
          Discard
        </Button>
        <Button
          data-test="custom-deal-table-merge-group-btn"
          className="revv-btn-sm btn-left-margin"
          disabled={!this._validateMergeButton()}
          onClick={this._openMergeGroupPopUp}>
          Merge Group
        </Button>
      </div>
    );
  };

  _getBlankView = () => {
    const { handleBlur, dealTableColumns } = this.props;
    const headers = dealTableColumns.map(column => column.text);
    return (
      <Table
        className="dealtable"
        colResize={false}
        readOnly
        headers={headers}
        section={{ data: [] }}
        handleBlur={handleBlur}
      />
    );
  };

  _getNormalView = () => {
    const {
      currency,
      handleBlur,
      metaData,
      rowData,
      dealTableColumns,
    } = this.props;
    const headers = dealTableColumns.map(column => column.text);
    const ungroupedData = getUngroupedData(metaData, rowData, dealTableColumns);
    const viewData = ungroupedData.map(row =>
      row.map((cell, index) => {
        if (dealTableColumns[index].currency) {
          return numberForamting(cell, CURRENCY_SYMBOL[currency]);
        }
        return cell;
      }),
    );
    return (
      <Table
        className="dealtable"
        colResize={false}
        readOnly
        headers={headers}
        section={{ data: viewData }}
        handleBlur={handleBlur}
      />
    );
  };

  _getGroupedView = () => {
    const {
      metaData,
      rowData,
      currency,
      discount,
      handleBlur,
      dealTableColumns,
    } = this.props;

    const headers = dealTableColumns.map(column => column.text);
    const tableView = [];

    const groupedData = getGroupedData(
      metaData,
      rowData,
      discount,
      dealTableColumns,
    );

    Object.keys(groupedData).forEach(groupKey => {
      const {
        rowData: data,
        groupTotal,
        discountAmount,
        discountPercent,
        discountedGroupTotal,
      } = groupedData[groupKey];
      const viewData = data.map(row =>
        row.map((cell, index) => {
          if (dealTableColumns[index].currency) {
            return numberForamting(cell, CURRENCY_SYMBOL[currency]);
          }
          return cell;
        }),
      );
      tableView.push(
        <Fragment key={uuid.v4()}>
          <div className="deal-table-groupname">{groupKey}</div>
          <Table
            className="dealtable"
            colResize={false}
            readOnly
            headers={headers}
            section={{ data: viewData }}
            handleBlur={handleBlur}
          />
          <div className="group-discount-summary">
            <div className="dealtable-deal-discountwrapper">
              <div className="row dealtable-deal-value">
                <div className="col-md-7">{`${groupKey} Subtotal:`}</div>
                <div className="col-md-5">
                  {groupTotal
                    ? numberForamting(groupTotal, CURRENCY_SYMBOL[currency])
                    : `${CURRENCY_SYMBOL[currency]} 0`}
                </div>
              </div>
              <div className="row dealtable-deal-value">
                <div className="col-md-7">Discount(%):</div>
                <div className="col-md-5">{discountPercent || 0}</div>
              </div>
              <div className="row dealtable-deal-value">
                <div className="col-md-7">Discount Value:</div>
                <div className="col-md-5">
                  {discountAmount
                    ? numberForamting(discountAmount, CURRENCY_SYMBOL[currency])
                    : `${CURRENCY_SYMBOL[currency]} 0`}
                </div>
              </div>
              <div className="row dealtable-deal-totalvalue">
                <div className="col-md-7">Total:</div>
                <div className="col-md-5">
                  {discountedGroupTotal
                    ? numberForamting(
                        discountedGroupTotal,
                        CURRENCY_SYMBOL[currency],
                      )
                    : `${CURRENCY_SYMBOL[currency]} 0`}
                </div>
              </div>
            </div>
          </div>
        </Fragment>,
      );
    });
    return tableView;
  };

  _getGroupedSummary = () => {
    const { handleBlur, currency, discount, groupSummary } = this.props;

    const headers = DEALTABLE_GROUPVIEW_HEADERS.map(header => header.label);

    const { data: mergeRowData, unmergedGroupExists } = getGroupSummaryData(
      discount,
      groupSummary,
    );
    if (unmergedGroupExists !== this.state.unmergedGroupExists) {
      this.setState({ unmergedGroupExists });
    }
    const tableData = mergeRowData.map(rowdata => {
      const { category, id, total } = rowdata[0];
      let attributes = { id };

      if (category === "group") {
        attributes = {
          ...attributes,
          header: true,
          editMergeGroup: this._editMergeGroup,
          discardMergeGroup: this._discardMergeGroup,
          rowOptions: [
            { key: "editMergeGroup", label: "Edit merge group" },
            { key: "discardMergeGroup", label: "Discard merge group" },
          ],
        };
      }

      const row = rowdata.slice(1).map((cell, index) => {
        if (
          category === "group" &&
          total === false &&
          DEALTABLE_GROUPVIEW_HEADERS[index].key !== "group_by_value"
        ) {
          return "";
        }
        if (DEALTABLE_GROUPVIEW_HEADERS[index].currency) {
          if (
            category === "group" &&
            !DEALTABLE_GROUPVIEW_HEADERS[index].total
          ) {
            return "";
          }
          return numberForamting(cell, CURRENCY_SYMBOL[currency]);
        }
        if (typeof cell === "number") {
          return cell.toString();
        }
        return cell;
      });
      return {
        data: row,
        attributes,
      };
    });
    return (
      <Table
        className="dealtable"
        colResize={false}
        readOnly
        headers={headers}
        section={{ data: tableData }}
        handleBlur={handleBlur}
      />
    );
  };

  _getMergedGroup = () => {
    const { currency, discount, groupSummary } = this.props;

    const { selectedGroups } = this.state;
    const headers = DEALTABLE_GROUPVIEW_HEADERS.map(header => header.label);

    const mergeRowData = getGroupSummaryData(discount, groupSummary).data;
    const tableData = mergeRowData.map(rowdata => {
      const { category, id, total } = rowdata[0];
      let attributes = { id };
      if (category === "group") {
        attributes = {
          ...attributes,
          header: true,
        };
      }

      const row = rowdata.slice(1).map((cell, index) => {
        if (
          category === "group" &&
          total === false &&
          DEALTABLE_GROUPVIEW_HEADERS[index].key !== "group_by_value"
        ) {
          return "";
        }
        if (DEALTABLE_GROUPVIEW_HEADERS[index].currency) {
          if (
            category === "group" &&
            !DEALTABLE_GROUPVIEW_HEADERS[index].total
          ) {
            return "";
          }
          return numberForamting(cell, CURRENCY_SYMBOL[currency]);
        }
        if (typeof cell === "number") {
          return cell.toString();
        }
        return cell;
      });

      const data =
        category === "unmerged_group"
          ? [
              {
                data: selectedGroups.includes(id),
                attributes: {
                  editable: true,
                  type: "checkbox",
                },
              },
            ]
          : [""];
      return {
        data: data.concat(row),
        attributes,
      };
    });

    return (
      <Table
        className="dealtable"
        colResize={false}
        readOnly
        headers={[""].concat(headers)}
        section={{ data: tableData }}
        handleBlur={this._updateGroupSummary}
        updateOnCellChange
      />
    );
  };

  _getDealtableGroupView = () => {
    const { discount, rowData } = this.props;
    const { mergeGroup } = this.state;
    let { dealtableView } = this.props;

    if (
      discount &&
      discount.groups &&
      Array.isArray(discount.groups) &&
      discount.groups.length === 0 &&
      dealtableView
    ) {
      // this.setState({ showGroupedData: false });
      dealtableView = "NORMAL_VIEW";
    }

    if (rowData && rowData.length === 0) return this._getBlankView();

    if (dealtableView === "NORMAL_VIEW") return this._getNormalView();

    if (dealtableView === "GROUPED_VIEW") return this._getGroupedView();

    if (dealtableView === "GROUPED_SUMMARY")
      return mergeGroup ? this._getMergedGroup() : this._getGroupedSummary();

    return [<b>Loading {DEAL_LABELS["deal-table-label"]}</b>];
  };

  _getDealtableFooter = () => {
    const { currency, discount, rowData } = this.props;
    const {
      deal_discount: dealDiscount,
      dealTotal,
      discountAmount,
      discountedDealTotal,
    } = discount;
    const hideDiscount = checkAppFlag(APP_FLAGS.DEAL_DISCOUNT); // Flags to display UI components based on Org setting
    if (rowData && rowData.length > 0) {
      return (
        <div className="dealtable-deal-discount">
          <div className="dealtable-deal-discountwrapper">
            {!hideDiscount && (
              <div className="row dealtable-deal-value">
                <div className="col-md-8">Subtotal:</div>
                <div className="col-md-4">
                  {numberForamting(dealTotal, CURRENCY_SYMBOL[currency])}
                </div>
              </div>
            )}
            {!hideDiscount && (
              <div className="row dealtable-deal-value">
                <div className="col-md-8">
                  {DEAL_LABELS["deal-label"]} Discount(%):
                </div>
                <div className="col-md-4">{dealDiscount}</div>
              </div>
            )}
            {!hideDiscount && (
              <div className="row dealtable-deal-value">
                <div className="col-md-8">
                  {DEAL_LABELS["deal-label"]} Discount Value:
                </div>
                <div className="col-md-4">
                  {numberForamting(discountAmount, CURRENCY_SYMBOL[currency])}
                </div>
              </div>
            )}
            <div className="row dealtable-deal-totalvalue">
              <div className="col-md-8">{DEAL_LABELS["deal-label"]} Total:</div>
              <div className="col-md-4">
                {hideDiscount
                  ? numberForamting(dealTotal, CURRENCY_SYMBOL[currency])
                  : numberForamting(
                      discountedDealTotal,
                      CURRENCY_SYMBOL[currency],
                    )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="dealtable-deal-discount">
        <div className="dealtable-deal-discountwrapper">
          <div className="row dealtable-deal-value">
            <div className="col-md-8">Subtotal:</div>
            <div className="col-md-4">0</div>
          </div>
          <div className="row dealtable-deal-value">
            <div className="col-md-8">
              {DEAL_LABELS["deal-label"]} Discount(%):
            </div>
            <div className="col-md-4">{dealDiscount}</div>
          </div>
          <div className="row dealtable-deal-value">
            <div className="col-md-8">
              {DEAL_LABELS["deal-label"]} Discount Value:
            </div>
            <div className="col-md-4">0</div>
          </div>
          <div className="row dealtable-deal-totalvalue">
            <div className="col-md-8">{DEAL_LABELS["deal-label"]} Total:</div>
            <div className="col-md-4">0</div>
          </div>
        </div>
      </div>
    );
  };

  _handleOnClick = () => {
    const { isComponentActive, isLocked, section } = this.props;
    if (!isLocked && !isComponentActive && section) {
      this.props.updateDocumentClickedComponentID(
        section.id,
        true,
        section.type,
      );
      if (this.props.createDocSectionRef) {
        this.props.createDocSectionRef(React.createRef());
      }
    }
  };

  _handleOnBlur = () => {
    if (this.props.isComponentActive) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  render() {
    const { section, isDocumentLocked, isSharedDocument } = this.props;
    const { showMergeGroupNamePopup, editMergeGroupID } = this.state;

    let mergeGroup;
    if (editMergeGroupID) {
      const {
        data: {
          groupSummary: { mergeGroupMetaData = [] },
        },
      } = section;
      mergeGroup = mergeGroupMetaData.find(
        group => group.id === editMergeGroupID,
      );
    }

    let popUpSpace = null;
    if (showMergeGroupNamePopup) {
      popUpSpace = (
        <Modal
          open={showMergeGroupNamePopup}
          center
          onClose={() => this._closeMergeGroupPopUp()}>
          <MergeGroups
            isEditMode={!!editMergeGroupID}
            mergeGroup={mergeGroup}
            handleMergeGroup={this._createMergeGroup}
            closePopUp={this._closeMergeGroupPopUp}
          />
        </Modal>
      );
    }
    if (this.props.dealTableId) {
      return (
        <div
          className={`customquotetable-component doc-dealtable-wrapper ${
            this.props.isComponentActive ? " active-customdealtable " : ""
          } ${
            this.props.isSharedDocument
              ? " shared-docoument-dealtable-wrapper "
              : ""
          }`}
          onClick={this._handleOnClick}
          onKeyPress={() => {}}
          onBlur={this._handleOnBlur}
          role="button"
          tabIndex={0}>
          <div className="custom-dealtable-header">
            <div className="custom-dealtable-titlewrapper">
              {!isSharedDocument && (
                <div
                  className="custom-dealtable-headertitle"
                  onClick={this._openDealTable}
                  onKeyDown={() => {}}
                  role="button"
                  tabIndex={0}>
                  <i className="custom-dealtable-headericon">
                    <FontAwesomeIcon icon={["far", "link"]} />
                  </i>
                  Go to {DEAL_LABELS["deal-table-label"]}
                </div>
              )}
            </div>
            {popUpSpace}
            {!isDocumentLocked && this._dealtableHeader()}
          </div>
          <div className="dealtable-component component-table">
            {this._getDealtableGroupView()}
            {this._getDealtableFooter()}
          </div>
        </div>
      );
    }
    return <CustomQuoteTableWrapper {...this.props} />;
  }
}

const mapStateToProps = (state, props) => {
  // REDUX KEYS DESTRUCTURING
  const {
    document: { status, isLocked },
    clickedActiveComponentId,
  } = state.DocumentStore;
  const { dealTableId } = state.QuotationStore;
  const {
    discount: { [dealTableId]: discount } = {},
    rowData: { [dealTableId]: rowData } = [],
    priceBook: { [dealTableId]: priceBook = {} } = {},
    columnDefs: { [dealTableId]: columnDefs } = [],
    metaData,
  } = state.DealTableStore;
  const { dealtableView, showGroupedData, data } = props.section;

  // DECLARATIONS
  const currency = (priceBook && priceBook.currency) || "USD";
  const view =
    dealtableView || (showGroupedData ? "GROUPED_VIEW" : "NORMAL_VIEW");
  // calculate group Summary
  let groupSummary =
    data && data instanceof Object && data.groupSummary
      ? data.groupSummary
      : {};
  groupSummary = getMergeGroups(discount, groupSummary);
  const isComponentActive = clickedActiveComponentId === props.section.id;
  const dealTableColumns = getDealTableColumns(columnDefs);
  return {
    isLocked,
    currency,
    dealTableId,
    dealtableView: view,
    discount,
    groupSummary,
    metaData,
    rowData,
    dealTableColumns,
    status,
    isComponentActive,
  };
};

const mapDispatchToProps = {
  updateDocumentClickedComponentID,
  toggleTabAndToolPanelData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomDealTable);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/CustomDealTable.js